export const AVATAR_TONE = {
  blue: 'blue',
  green: 'green',
  orange: 'orange',
  red: 'red',
  gray: 'gray',
} as const

export type AvatarTone = (typeof AVATAR_TONE)[keyof typeof AVATAR_TONE]

export interface ActivityHistoryUser {
  id: string
  firstName: string
  lastName: string
  tone?: AvatarTone
}

export interface ActivityHistoryChange {
  id: string
  field: string
  oldValue: string
  newValue: string
  pinned?: boolean
}

export const ACTIVITY_ENTRY_KIND = {
  session: 'session',
  event: 'event',
} as const

export type ActivityEntryKind =
  (typeof ACTIVITY_ENTRY_KIND)[keyof typeof ACTIVITY_ENTRY_KIND]

interface ActivityHistoryEntryBase {
  id: string
  user: ActivityHistoryUser
  occurredAt: string
}

export interface ActivityHistorySessionEntry extends ActivityHistoryEntryBase {
  kind: typeof ACTIVITY_ENTRY_KIND.session
  changes: ActivityHistoryChange[]
  resourceLabel?: string
}

export interface ActivityHistoryEventEntry extends ActivityHistoryEntryBase {
  kind: typeof ACTIVITY_ENTRY_KIND.event
  label: string
  detail?: string
}

export type ActivityHistoryEntry =
  | ActivityHistorySessionEntry
  | ActivityHistoryEventEntry
